// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__gIPv_","gfeWrapper":"CalendarEvent_gfeWrapper__LsZ1f"};